/**
 * fixTable.jsx
 *
 * @Author: apple
 * @Date: 2017/12/29 00:19
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import easyToMap from '../util/easyToMap';
import ChevronRight from '../icons/internals/ChevronRight';
import ExpandMore from '../icons/internals/ExpandMore';
import TableHeader from './TableHeader';
import TableTbody from './TableTbody';
import ColGroup from './colGroup';
import TableHeaderRow from './TableHeaderRow';
import pubsub from '../util/observer';
import merge from '../util/merge';
import Checkbox from '../checkbox';

/**
 * @ignore
 * */
class ItemTable extends React.Component {
  static propTypes = {
    expandOpt: PropTypes.object,
    children: PropTypes.object,
    expandRender: PropTypes.func,
  };

  static defaultProps = {
    expandRender: () => <div>展开栏</div>,
  };

  constructor(props, context) {
    super(props, context);
    const { dataSource, columns } = this.props;
    const sortState = {};
    this.rules = [];
    columns.forEach(item => {
      const { sort, key } = item;
      if (sort) {
        sortState[key] = 'sort';
      }
    });
    this.pubsubEvent = [];
    this.state = {
      showExpandContent: [],
      checkboxArray: [],
      expandRowIds: [],
      data: dataSource,
      rowHeightArray: [],
      tdWidthArray: [],
      expandSumRow: 0,
      sortState: { ...sortState },
    };
  }

  componentDidMount() {
    const { scroll } = this.props;
    if (scroll.y) {
      this.scrollTbody.addEventListener('scroll', this.handleBodyScrollPosition, false);
      this.scrollTbody.addEventListener('mouseover', this.handleMouseOn, false);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { dataSource, scrollTop, columns } = this.props;
    if (JSON.stringify(dataSource) !== JSON.stringify(nextProps.dataSource)) {
      this.setState({
        data: nextProps.dataSource,
        expandRowIds: [],
        checkboxArray: [],
      });
    }

    if (JSON.stringify(columns) !== JSON.stringify(nextProps.columns)) {
      const sortState = {};
      nextProps.columns.forEach(item => {
        const { sort, key } = item;
        if (sort) {
          sortState[key] = 'sort';
        }
      });
      this.setState({
        sortState: { ...sortState },
      });
    }

    if (nextProps.scrollTop !== scrollTop) {
      this.scrollTbody.scrollTop = nextProps.scrollTop;
    }
  }

  componentWillUnmount() {
    for (const item in this.pubsubEvent) {
      pubsub.unsubscribe(item);
    }
  }

  handleMouseOn = () => {
    const { position, activeMouse } = this.props;
    activeMouse(position);
  };

  handleBodyScrollPosition = e => {
    const { handleBodyScrollVertical, position } = this.props;
    const target = e.target;
    const { thead, scrollTbody } = this;
    if (target.scrollLeft !== this.lastScrollLeft) {
      if (target === scrollTbody && thead) {
        thead.scrollLeft = target.scrollLeft;
      } else if (target === thead && scrollTbody) {
        scrollTbody.scrollLeft = target.scrollLeft;
      }
    }
    this.lastScrollLeft = target.scrollLeft;
    if (e.target.className !== 'ne-table-item-header') {
      handleBodyScrollVertical && handleBodyScrollVertical(e, position);
    }
  };

  /**
   * 通用事件捕获，通过设置type来获取事件处理类型 todo 考虑支持无限加载
   * */
  handleBtnListener = (event, id, type) => {
    const { dataSource, checkboxCallback } = this.props;
    let idArray = [...this.state[type]];
    const isContainId = idArray.filter(item => id === item).length;
    const idArrayLen = idArray.length;
    const dataSourceLen = dataSource.length;
    if (id === 'header') {
      if (idArrayLen === 0 || (idArrayLen > 0 && idArrayLen < dataSourceLen)) {
        idArray = dataSourceLen ? easyToMap(dataSourceLen) : ['all'];
      } else {
        idArray = [];
      }
    } else if (isContainId) {
      idArray.forEach((item, index) => {
        if (item === id) {
          idArray.splice(index, 1);
        }
      });
    } else {
      idArray.push(id);
    }
    this.setState({
      [type]: idArray,
    });
    if (type === 'checkboxArray') {
      checkboxCallback(
        this.state.data.filter((item, index) => {
          let bool = false;
          idArray.forEach(id => {
            if (id === index) {
              bool = true;
            }
          });
          return bool;
        }),
      );
    }
  };

  initTableColumns = () => {
    const { checkbox, columns, dataSource, position, expandOpt, children } = this.props;
    const { checkboxArray, expandRowIds } = this.state;
    const renderColumns = merge(columns);
    this.rules = [];
    // 展开类型
    const showExpand = (expandOpt && expandOpt.display && position !== 'right') || children;
    if (showExpand) {
      const expandBtn = id => {
        const filterArray = expandRowIds.filter(item => item - 1 === id);
        const type = filterArray.length ? 'down-arrow' : 'right-arrow';
        const Component = filterArray.length ? ExpandMore : ChevronRight;
        let icon = <Component style={{ userSelect: 'none' }} />;
        if ((expandOpt || children).display) {
          icon = (expandOpt || children).expandIcon;
          if (filterArray.length) {
            icon = (expandOpt || children).shrinkIcon;
          }
        }
        return icon;
      };
      renderColumns.unshift({
        key: 'expandBtn',
        width: 50,
        renderHeader: () => <div />,
        render: expandBtn,
      });
    }

    // 多选框
    if (checkbox) {
      const checkElm = id => {
        let checked = '';
        if (checkboxArray.length === dataSource.length && checkboxArray.length) {
          checked = 'checked';
        } else {
          const filterArray = checkboxArray.filter(item => item === id);
          checked = filterArray.length ? 'checked' : '';
        }
        return (
          <Checkbox
            checked={checked}
            onChange={event => this.handleBtnListener(event, id, 'checkboxArray')}/>
        );
      };
      renderColumns.unshift({
        key: 'checkbox',
        width: 50,
        renderHeader: checkElm,
        render: checkElm,
      });
    }

    renderColumns.forEach(item => {
      this.rules.push(item.key);
    });
    return renderColumns;
  };

  handleSetSort = (key, id) => {
    const { columns, onSort, checkbox, expandOpt, children } = this.props;
    const sortState = { ...this.state.sortState };
    let nextType = '';
    switch (this.state.sortState[key]) {
      case 'sort':
        nextType = 'sort-down';
        break;
      case 'sort-down':
        nextType = 'sort-up';
        break;
      case 'sort-up':
        nextType = 'sort';
        break;
      default:
        return;
    }
    Object.keys(sortState).forEach(item => {
      sortState[item] = 'sort';
    });
    sortState[key] = nextType;
    if (checkbox) {
      id -= 1;
    }
    if ((expandOpt && expandOpt.display) || (children && children.display)) {
      id -= 1;
    }
    this.setState(
      {
        sortState: { ...sortState, [key]: nextType },
      },
      () => {
        onSort && onSort(columns[id], nextType);
      },
    );
  };

  handleInnerScrollEvent = elm => {
    const { handleInnerScrollEvent, tbodyRef } = this.props;
    tbodyRef && tbodyRef(elm);
    this.scrollTbody = elm;
    handleInnerScrollEvent && handleInnerScrollEvent(elm);
  };

  getTableRef = el => {
    const { tableRef } = this.props;
    this.tableItemRef = el;
    tableRef && tableRef(el);
  };

  render() {
    const {
      position,
      onClickTh,
      styles,
      textCenter,
      prefixCls,
      hideTableTitle,
      stripe,
      columnsId,
      shouldScroll,
      scroll,
      theadRef,
      tbodyRef,
      tdWidthArray,
      warpWidth,
      rowHeightArray,
      scrollBarWidth,
      allBorder,
      warpBorder,
      handleMouseEnter,
      handleMouseLeave,
      checkbox,
      baseHeaderHeight,
      expandOpt,
      children,
      mainTbody,
      pubsubEventString,
      hover,
      noDataRender,
      theadRowRef,
      showFixTable,
      mainDataSource,
      width: containerWidth,
    } = this.props;
    const { data, expandRowIds, sortState, tbodyScroll } = this.state;
    const renderColumns = this.initTableColumns();

    // 赋予固定栏整体宽度
    let innerTableWidth = 0;
    const renderStyle = { ...styles };
    if (position === 'left' || position === 'right') {
      columnsId.forEach(id => {
        if (position === 'left') {
          if (checkbox) {
            innerTableWidth += 50;
          }
          if ((expandOpt && expandOpt.display) || (children && children.display)) {
            innerTableWidth += 50;
          }
        }
        if (tdWidthArray[id]) {
          innerTableWidth += tdWidthArray[id];
        }
      });
      let width = innerTableWidth;
      if (position === 'right') {
        width =
          scrollBarWidth && shouldScroll
            ? innerTableWidth + scrollBarWidth - 1
            : innerTableWidth - 1;
      }
      renderStyle.width = width;
    } else {
      renderStyle.width =
        scrollBarWidth || shouldScroll ? containerWidth : containerWidth + scrollBarWidth;
    }
    const tableClassName = classNames(`${prefixCls}-${position}-fixed`, {
      'ne-table-exist-scroll-y': scroll.y && allBorder && !warpBorder,
      'ne-table-visible': showFixTable && position !== 'main',
      'ne-table-hidden': !showFixTable && position !== 'main',
    });
    const theadClassName = classNames(
      `${prefixCls}-thead`,
      {
        'ne-table-border-none': position === 'right' || position === 'left',
      },
      { 'display-none': hideTableTitle },
    );
    const tbodyClassName = classNames(`${prefixCls}-tbody`, {
      'ne-table-border-none': position === 'right' || position === 'left',
    });
    const headerStyle = {
      overflowY: 'scroll',
      overflowX: position === 'main' && shouldScroll ? 'auto' : 'hidden',
    };
    if (scroll.y) {
      if (position === 'main') {
        headerStyle.maxHeight = scroll.y;
      } else {
        headerStyle.maxHeight = +scroll.y.split('px')[0] - 15;
        if (!scrollBarWidth || !shouldScroll) {
          headerStyle.maxHeight = +scroll.y.split('px')[0];
        }
      }
    } else {
      headerStyle.overflowY = 'hidden';
    }

    const selfPrefixCls = `${prefixCls}-item`;
    const theadProps = {
      theadClassName,
      renderColumns,
      handleSetSort: this.handleSetSort,
      sortState,
      onClickTh,
      textCenter,
      tdWidthArray,
      warpWidth,
      position,
      prefixCls: selfPrefixCls,
      scroll: tbodyScroll,
      tableHeaderRowRef: el => {
        theadRowRef && theadRowRef(el);
        this.theadRow = el;
      },
      tableHeaderRef: el => {
        theadRef && theadRef(el);
        this.thead = el;
      },
      width: renderStyle.width,
      height: baseHeaderHeight,
      handleBodyScrollLeft: this.handleBodyScrollPosition,
    };
    const tableHeaderRowProps = Object.assign({}, theadProps);
    const tbodyProps = {
      tbodyClassName,
      data,
      expandRowIds,
      renderColumns,
      selfPrefixCls,
      stripe,
      rowHeightArray,
      position,
      tableTbodyRef: el => {
        tbodyRef && tbodyRef(el);
        this.tbody = el;
      },
      handleBodyScrollLeft: this.handleBodyScrollPosition,
      rules: this.rules,
      handleMouseEnter,
      handleMouseLeave,
      mainTbody,
      pubsubEventString,
      expandOpt,
      children,
      checkbox,
      hover,
      noDataRender,
      mainDataSource,
    };

    return (
      <div className={tableClassName} ref={this.getTableRef}>
        {scroll.y && <TableHeader {...theadProps} />}
        <div
          className={`${selfPrefixCls}-tbody`}
          style={headerStyle}
          ref={this.handleInnerScrollEvent}>
          <table style={renderStyle}>
            <ColGroup renderColumns={renderColumns} />
            {!scroll.y && <TableHeaderRow {...tableHeaderRowProps} />}
            <TableTbody {...tbodyProps} />
          </table>
        </div>
      </div>
    );
  }
}

export default ItemTable;



// WEBPACK FOOTER //
// ./src/table/ItemTable.jsx